import { useAppDispatch } from 'store/store';
import { loadingActions } from 'store';
import toast from 'shared/utils/toast';
import { TenantPage } from 'layouts';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { costElementService } from 'shared/services';
import { periodicCostElementService } from 'features/cost-analysis/costs/api/periodic-cost-element.service';
import CostElementForm from '../components/CostElementForm';

const initCostElement = {
  id: null,
  active: true,
  code: null,
  object_id: null,
  content_type: null,
  cost: null,
  description: null,
  date: null
};
export function AddCostElement() {
  const { t } = useTranslation();
  const translationPrefix = 'pages.cost.new';
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const createCostElement = async (values, isPeriodical) => {
    dispatch(loadingActions.startLoading());

    (isPeriodical ? periodicCostElementService : costElementService).add(values).then(() => {
      toast.crud.successCreate('Elemento di costo');
      navigate('..');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <CostElementForm onSubmit={createCostElement} costElement={initCostElement} />
    </TenantPage>
  );
}

export default AddCostElement;
